import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import LiveStats from '../components/home/LiveStats';
import ComingSoonProducts from '../components/home/ComingSoonProducts';
import VideoSection from '../components/home/VideoSection';
import GallerySection from '../components/home/GallerySection';
import ContactForm from '../components/home/ContactForm';
import '../styles/home.css';

const Home = () => {
  useEffect(() => {
    if (window.lucide) {
      window.lucide.createIcons();
    }
  }, []);

  return (
    <div className="home-page">
      <Header />

      <div className="marquee-container">
        <div className="marquee-content">
          <span>🎁 Win Exciting Gift Money Prizes Every Month! • Join Offer Lifetime# VIP Program Today • Transparent & Fair Prize Distribution • Thousands of Happy Winners • Get Your VIP Token Now • Limited Slots Available • 🏆 Real Winners, Real Prizes • Jaisa Naam Vaisa Kaam • Trusted Platform Since Day One • </span>
          <span>🎁 Win Exciting Gift Money Prizes Every Month! • Join Offer Lifetime# VIP Program Today • Transparent & Fair Prize Distribution • Thousands of Happy Winners • Get Your VIP Token Now • Limited Slots Available • 🏆 Real Winners, Real Prizes • Jaisa Naam Vaisa Kaam • Trusted Platform Since Day One • </span>
        </div>
      </div>

      <section id="home" className="hero-section">
        <div className="hero-bg">
          <div className="floating-orb orb-1"></div>
          <div className="floating-orb orb-2"></div>
          <div className="floating-orb orb-3"></div>
        </div>
        {/* <img
          src={heroImage}
          alt="Hero Banner"
          className="hero-image"
        /> */}

        <div className="hero-content" style={{ display: 'none' }}>
          <div className="hero-badge">
            <i data-lucide="gift"></i>
            <span>Exclusive Program</span>
          </div>

          <h1 className="hero-title">
            OFFER LIFETIME<span className="text-gold">#</span>:<br />
            WIN GIFT MONEY PRIZES
          </h1>

          <p className="hero-description">
            Unlock Your Potential. Experience the Thrill of Winning. Join thousands of participants in our exclusive VIP program and get a chance to win exciting gift money prizes every month.
          </p>

          <div className="hero-buttons">
            <Link to="/register" className="btn btn-primary">Get Your VIP Token Now</Link>
            <a href="#about" className="btn btn-secondary">Learn More</a>
          </div>

          <div className="scroll-indicator">
            <i data-lucide="chevron-down"></i>
          </div>
        </div>
      </section>

      <LiveStats />

      <VideoSection />
      
      <ComingSoonProducts />

      <section id="about" className="section section-white">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">About Our Brand: Jaisa Name Vaisa Kaam</h2>
            <p className="section-subtitle">(As the Name, So the Work)</p>
          </div>

          <div className="grid grid-2">
            <div className="about-text">
              <p className="text-lg">
                At Offer Lifetime#, our name reflects our commitment. "Jaisa Name Vaisa Kaam" means we deliver exactly what we promise. We are dedicated to creating a platform where trust, transparency, and opportunity come together.
              </p>
              <p className="text-lg">
                Our mission is to provide genuine opportunities for people to win gift money prizes through a fair and transparent system. We believe in building lasting relationships with our community based on integrity and mutual respect.
              </p>
            </div>

            <div className="about-image">
              <img src="/images/placeholder-trust.svg" alt="Trust and Integrity" className="placeholder-img" />
            </div>
          </div>

          <div className="grid grid-3">
            <div className="feature-card">
              <div className="feature-number">1</div>
              <i data-lucide="check-circle" className="feature-icon"></i>
              <h3 className="feature-title">Transparency</h3>
              <p className="feature-description">Every process is clear and open. We believe in complete transparency in our operations and prize distributions.</p>
            </div>

            <div className="feature-card">
              <div className="feature-number">2</div>
              <i data-lucide="shield" className="feature-icon"></i>
              <h3 className="feature-title">Integrity</h3>
              <p className="feature-description">We operate with the highest standards of honesty and fairness. Your trust is our foundation.</p>
            </div>

            <div className="feature-card">
              <div className="feature-number">3</div>
              <i data-lucide="users" className="feature-icon"></i>
              <h3 className="feature-title">Community</h3>
              <p className="feature-description">Building a strong, supportive community of winners. Together we grow and celebrate success.</p>
            </div>
          </div>
        </div>
      </section>

      <section id="participate" className="section section-gray yogi">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">How to Participate: Complete Registration Form</h2>
            <h3 className="section-subtitle-large">for Your VIP Token</h3>
            <p className="section-description">
              Getting started is simple and takes just a few minutes. Follow these easy steps to join our exclusive community and start your journey towards winning exciting prizes.
            </p>
          </div>

          <div className="grid grid-4">
            <div className="step-card">
              <div className="step-number">01</div>
              <i data-lucide="globe" className="step-icon"></i>
              <h3 className="step-title">Visit Our Website</h3>
              <p className="step-description">Navigate to our official website and explore the exciting opportunities waiting for you.</p>
            </div>

            <div className="step-card">
              <div className="step-number">02</div>
              <i data-lucide="file-text" className="step-icon"></i>
              <h3 className="step-title">Complete the Form</h3>
              <p className="step-description">Fill in all the required details in our simple registration form with accurate information.</p>
            </div>

            <div className="step-card">
              <div className="step-number">03</div>
              <i data-lucide="award" className="step-icon"></i>
              <h3 className="step-title">Receive Your VIP Token</h3>
              <p className="step-description">Upon successful registration, you will receive your unique VIP Token Number instantly.</p>
            </div>

            <div className="step-card">
              <div className="step-number">04</div>
              <i data-lucide="bell" className="step-icon"></i>
              <h3 className="step-title">Stay Tuned & Win!</h3>
              <p className="step-description">Once registered, keep an eye on our announcements. Winners are selected regularly!</p>
            </div>
          </div>

          <div className="text-center mt-large">
            <p className="text-lg font-semibold mb-medium text-white">

              Don't miss out on this incredible opportunity! Register now and become part of our winning community.
            </p>
            <Link to="/register" className="btn btn-blue">Start Registration Now</Link>
          </div>
        </div>
      </section>

      <GallerySection />

      <section id="prizes" className="section section-white">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Current Prize Drawings: Generous Opportunities Await!</h2>
          </div>

          <div className="grid grid-2">
            <div className="prize-info">
              <p className="text-lg mb-medium">
                We are thrilled to announce our current prize drawing structure, designed to reward our valued VIP token holders with exciting gift money prizes. Our tiered system ensures fair distribution and multiple winning opportunities.
              </p>

              <div className="benefits-list">
                <div className="benefit-item">
                  <i data-lucide="trophy" className="benefit-icon"></i>
                  <div>
                    <h4 className="benefit-title">Exclusive Prizes</h4>
                    <p className="benefit-text">Win substantial gift money prizes reserved only for VIP token holders.</p>
                  </div>
                </div>

                <div className="benefit-item">
                  <i data-lucide="gift" className="benefit-icon"></i>
                  <div>
                    <h4 className="benefit-title">Tiered Chances</h4>
                    <p className="benefit-text">Multiple prize tiers mean more opportunities to win based on your VIP number.</p>
                  </div>
                </div>

                <div className="benefit-item">
                  <i data-lucide="check-circle" className="benefit-icon"></i>
                  <div>
                    <h4 className="benefit-title">Ongoing Draws</h4>
                    <p className="benefit-text">Regular prize drawings ensure continuous excitement and winning opportunities.</p>
                  </div>
                </div>
              </div>

              <div className="prize-image-container">
                <img src="/images/placeholder-prize.svg" alt="Gift Money Prizes" className="placeholder-img" />
              </div>
            </div>

            <div className="prize-tiers">
              <div className="tier-card tier-1">
                <div className="tier-badge">TIER 1</div>
                <div className="tier-range">
                  <p className="tier-label">VIP Token Numbers</p>
                  <p className="tier-numbers">#100 - #1000</p>
                </div>
                <div className="tier-winners">
                  <div className="winner-count">3</div>
                  <p className="winner-text">Gift Money Prize Winners</p>
                </div>
                <i data-lucide="trophy" className="tier-icon"></i>
              </div>

              <div className="tier-card tier-2">
                <div className="tier-badge">TIER 2</div>
                <div className="tier-range">
                  <p className="tier-label">VIP Token Numbers</p>
                  <p className="tier-numbers">#1001 - #5000</p>
                </div>
                <div className="tier-winners">
                  <div className="winner-count">4</div>
                  <p className="winner-text">Gift Money Prize Winners</p>
                </div>
                <i data-lucide="trophy" className="tier-icon"></i>
              </div>
            </div>
          </div>

          <div className="prize-image-cards">
            <div className="prize-image-card">
              <img src="/images/image2.png" alt="Current Prize Drawings" className="prize-card-img" />
            </div>
            <div className="prize-image-card">
              <img src="/images/image3.png" alt="Dream Getaway Sweepstakes" className="prize-card-img" />
            </div>
            <div className="prize-image-card">
              <img src="/images/image4.png" alt="Variety of Prizes" className="prize-card-img" />
            </div>
          </div>
        </div>
      </section>

      <section className="section section-gradient">
        <div className="container">
          <div className="section-header text-white">
            <h2 className="section-title" style={{ color: 'white' }}>Upcoming Opportunities: More Excitement Coming Soon!</h2>
            <p className="section-description text-blue-100">
              The future is bright at Offer Lifetime#. We are constantly working to enhance your experience and bring you even more exciting opportunities to win.
            </p>
          </div>

          <div className="grid grid-3">
            <div className="opportunity-card">
              <i data-lucide="trending-up" className="opportunity-icon"></i>
              <h3 className="opportunity-title">Expanded Prize Pools</h3>
              <p className="opportunity-description">Anticipate larger prize pools with more winners as our community grows and thrives together.</p>
            </div>

            <div className="opportunity-card">
              <i data-lucide="sparkles" className="opportunity-icon"></i>
              <h3 className="opportunity-title">Innovative Prize Categories</h3>
              <p className="opportunity-description">We're exploring new and exciting prize categories to keep the experience fresh and rewarding.</p>
            </div>

            <div className="opportunity-card">
              <i data-lucide="globe" className="opportunity-icon"></i>
              <h3 className="opportunity-title">Broader Reach</h3>
              <p className="opportunity-description">As Offer Lifetime# expands, we plan to introduce regional and international prize opportunities.</p>
            </div>
          </div>

          <div className="text-center mt-large">
            <p className="text-xl font-semibold text-white mb-medium">
              Stay connected to be the first to know about new opportunities!
            </p>
            <Link to="/register" className="btn btn-white">Get Your VIP Token</Link>
          </div>
        </div>
      </section>

      <section id="social" className="section section-white">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Follow Us: Connect with Offer Lifetime™</h2>
            <p className="section-description">
              Staying connected with Offer Lifetime™ is crucial for maximizing your chances to win and keeping abreast of all our exciting developments. We leverage various social media platforms to provide real-time updates, announce new prize draws, share winner stories, and engage directly with our vibrant community. Don't miss out on important announcements – it is mandatory to follow us across our official channels!
            </p>
          </div>

          <div className="grid grid-3">
            <div className="social-card social-facebook">
              <i data-lucide="facebook" className="social-icon"></i>
              <h3 className="social-title">Facebook</h3>
              <p className="social-description">Join our thriving Facebook community for daily updates, exclusive content, and live Q&A sessions. Interact with fellow participants and get all your questions answered directly.</p>
              <a href="https://www.facebook.com/share/BGN8Hsn5brW3ymSZ/" target="_blank" rel="noopener noreferrer" className="btn btn-facebook">Follow</a>
            </div>

            <div className="social-card social-instagram">
              <i data-lucide="instagram" className="social-icon"></i>
              <h3 className="social-title">Instagram</h3>
              <p className="social-description">Follow our Instagram page for captivating visuals, behind-the-scenes glimpses, and quick announcements. Discover inspiring winner stories and vibrant content.</p>
              <a href="https://www.instagram.com/invites/contact/?igsh=ujoji6x0nujz&utm_content=wafs0kc" target="_blank" rel="noopener noreferrer" className="btn btn-instagram">Follow</a>
            </div>

            <div className="social-card social-youtube">
              <i data-lucide="youtube" className="social-icon"></i>
              <h3 className="social-title">YouTube</h3>
              <p className="social-description">Subscribe to our YouTube channel for in-depth video content, including draw explanations, testimonials, and brand narratives. See Offer Lifetime™ in action!</p>
              <a href="https://www.youtube.com/@OfferLifeTime" target="_blank" rel="noopener noreferrer" className="btn btn-youtube">Subscribe</a>
            </div>
          </div>

          <div className="social-engagement-note">
            <p className="text-lg">
              These platforms are your primary source for timely information regarding prize draws, eligibility, and new initiatives. By following, liking, and subscribing, you ensure you're always in the loop and never miss an opportunity to participate or celebrate a win.
            </p>
          </div>

          <div className="social-final-note">
            <p className="text-lg">
              Engage with our content, share your excitement, and become an active member of the Offer Lifetime™ family. Your active participation on social media also helps us reach a wider audience, thereby fueling our ability to offer even more significant prizes and charitable contributions in the future.
            </p>
          </div>
        </div>
      </section>

      <section id="winners" className="section section-gray">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Winners Showcase: Celebrating Our Gift Money Prize Recipients!</h2>
          </div>

          <div className="section-description-block">
            <p className="text-lg">
              We are proud to celebrate the success of our winners! While we respect the privacy of our prize recipients, we share their experiences with their consent to inspire and motivate our community.
            </p>
            <p className="text-lg">
              These testimonials represent real winners who have received their gift money prizes through our transparent and fair selection process.
            </p>
          </div>

          <div className="grid grid-3">
            <div className="testimonial-card">
              <i data-lucide="quote" className="quote-icon"></i>
              <p className="testimonial-text">"I couldn't believe it when I received the notification! The money was transferred exactly as promised. Offer Lifetime# truly delivers on its word."</p>
              <div className="testimonial-author">
                <div className="author-avatar">RK</div>
                <div>
                  <p className="author-name">Rajesh K.</p>
                  <p className="author-title">Prize Winner</p>
                </div>
              </div>
            </div>

            <div className="testimonial-card">
              <i data-lucide="quote" className="quote-icon"></i>
              <p className="testimonial-text">"Simple to participate, transparent process, and amazing prizes. I won in my second month of registration. Highly recommend!"</p>
              <div className="testimonial-author">
                <div className="author-avatar">PS</div>
                <div>
                  <p className="author-name">Priya S.</p>
                  <p className="author-title">Prize Winner</p>
                </div>
              </div>
            </div>

            <div className="testimonial-card">
              <i data-lucide="quote" className="quote-icon"></i>
              <p className="testimonial-text">"Offer Lifetime# delivered exactly what they promised. The entire process was smooth, and I received my prize money without any hassle."</p>
              <div className="testimonial-author">
                <div className="author-avatar">AM</div>
                <div>
                  <p className="author-name">Amit M.</p>
                  <p className="author-title">Prize Winner</p>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center mt-large">
            <p className="text-xl font-semibold mb-medium">Join our community of winners today!</p>
            <Link to="/register" className="btn btn-blue">Get Your VIP Token</Link>
          </div>
        </div>
      </section>

      <section className="section section-white">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Our Promise: How We Generate and Share Earnings</h2>
            <h3 className="section-subtitle-large">with Our Community</h3>
          </div>

          <div className="section-description-block">
            <p className="text-lg">
              Transparency is at the heart of everything we do. We want you to understand exactly how Offer Lifetime# operates and how we're able to offer these exciting prize opportunities.
            </p>
            <p className="text-lg">
              Our business model is built on sustainable growth and fair sharing. Here's how we generate earnings and distribute them back to our community:
            </p>
          </div>

          <div className="grid grid-3">
            <div className="promise-card">
              <div className="promise-header">
                <div className="promise-number">1</div>
                <i data-lucide="trending-up" className="promise-icon"></i>
              </div>
              <h3 className="promise-title">Brand Growth</h3>
              <p className="promise-description">We build partnerships with brands and generate revenue through ethical business practices.</p>
            </div>

            <div className="promise-card">
              <div className="promise-header">
                <div className="promise-number">2</div>
                <i data-lucide="dollar-sign" className="promise-icon"></i>
              </div>
              <h3 className="promise-title">Earnings Accumulation</h3>
              <p className="promise-description">Revenue from our business activities is carefully accumulated and allocated for community benefits.</p>
            </div>

            <div className="promise-card">
              <div className="promise-header">
                <div className="promise-number">3</div>
                <i data-lucide="users" className="promise-icon"></i>
              </div>
              <h3 className="promise-title">Fair Distribution</h3>
              <p className="promise-description">A significant portion of earnings is set aside specifically for prize distributions to our VIP members.</p>
            </div>

            <div className="promise-card">
              <div className="promise-header">
                <div className="promise-number">4</div>
                <i data-lucide="gift" className="promise-icon"></i>
              </div>
              <h3 className="promise-title">Prize Draws</h3>
              <p className="promise-description">Regular prize drawings are conducted transparently, ensuring every VIP token holder has a fair chance.</p>
            </div>

            <div className="promise-card">
              <div className="promise-header">
                <div className="promise-number">5</div>
                <i data-lucide="heart" className="promise-icon"></i>
              </div>
              <h3 className="promise-title">Charitable Giving</h3>
              <p className="promise-description">We contribute to social causes, including support for the Army Fund and community welfare programs.</p>
            </div>

            <div className="promise-card">
              <div className="promise-header">
                <div className="promise-number">6</div>
                <i data-lucide="sparkles" className="promise-icon"></i>
              </div>
              <h3 className="promise-title">Community Empowerment</h3>
              <p className="promise-description">By sharing our success, we empower our community and create a cycle of growth and prosperity.</p>
            </div>
          </div>

          <div className="commitment-box">
            <h3 className="commitment-title">Our Commitment to You</h3>
            <p className="commitment-text">
              We promise to maintain complete transparency in our operations, conduct fair prize drawings, and continue growing our community while giving back to society. Your trust is our most valuable asset.
            </p>
          </div>
        </div>
      </section>

      <section className="section section-army">
        <div className="container">
          <div className="section-header text-white">
            <h2 className="section-title" style={{ color: 'white' }}>Supporting Our Heroes: Our Contributions to the Army Fund</h2>
          </div>

          <div className="grid grid-2">
            <div className="army-content">
              <p className="text-lg text-green-100 mb-medium">
                At Offer Lifetime#, we believe in giving back to those who give everything for our nation. A portion of our earnings is dedicated to supporting the Army Fund, honoring the courage and sacrifice of our military personnel.
              </p>
              <p className="text-lg text-green-100 mb-large">
                Our commitment to the Army Fund reflects our values of patriotism, gratitude, and social responsibility. We are proud to contribute to the welfare of our soldiers and their families.
              </p>

              <div className="army-benefits">
                <div className="army-benefit">
                  <i data-lucide="heart" className="army-icon"></i>
                  <div>
                    <h4 className="army-title">Gratitude</h4>
                    <p className="army-text">Expressing our deep gratitude to the brave soldiers who protect our nation and ensure our safety.</p>
                  </div>
                </div>

                <div className="army-benefit">
                  <i data-lucide="shield" className="army-icon"></i>
                  <div>
                    <h4 className="army-title">Welfare</h4>
                    <p className="army-text">Supporting the welfare of military personnel and their families through dedicated contributions.</p>
                  </div>
                </div>

                <div className="army-benefit">
                  <i data-lucide="users" className="army-icon"></i>
                  <div>
                    <h4 className="army-title">Community</h4>
                    <p className="army-text">Extending our community spirit to honor and support those who serve our country with dedication.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="army-image-container">
              <img src="/images/army.png" alt="Honoring Our Heroes" className="placeholder-img" />
            </div>
          </div>

          <div className="army-note">
            <p className="text-xl font-semibold text-white">
              Together, we can make a difference in the lives of our brave soldiers and their families. Thank you for being part of this noble cause.
            </p>
          </div>
        </div>
      </section>

      <section className="section section-gray">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Terms & Conditions: Official Rules and Eligibility Requirements</h2>
          </div>

          <div className="warning-box">
            <i data-lucide="alert-circle" className="warning-icon"></i>
            <div>
              <h3 className="warning-title">Important Notice</h3>
              <p className="warning-text">
                Please read these terms and conditions carefully before participating. By registering for a VIP Token, you acknowledge that you have read, understood, and agree to be bound by these terms.
              </p>
            </div>
          </div>

          <div className="accordion">
            <div className="accordion-item active">
              <button className="accordion-header">
                <span className="accordion-icon">▼</span>
                <span className="accordion-title">Eligibility</span>
                <i data-lucide="chevron-down" className="accordion-chevron"></i>
              </button>
              <div className="accordion-content">
                <ul className="terms-list">
                  <li>Participants must be of legal age (18 years or older) in their jurisdiction.</li>
                  <li>Only valid VIP Token Numbers obtained through official registration are eligible.</li>
                  <li>Employees, affiliates, and immediate family members of Offer Lifetime# are not eligible to participate.</li>
                  <li>Participants must be residents of eligible countries as specified on our website.</li>
                </ul>
              </div>
            </div>

            <div className="accordion-item">
              <button className="accordion-header">
                <span className="accordion-icon">▼</span>
                <span className="accordion-title">Participation</span>
                <i data-lucide="chevron-down" className="accordion-chevron"></i>
              </button>
              <div className="accordion-content">
                <ul className="terms-list">
                  <li>Completing the official registration form with accurate information is mandatory.</li>
                  <li>One VIP Token Number per individual. Multiple registrations will result in disqualification.</li>
                  <li>Maintaining an active subscription to our social media channels is required for eligibility.</li>
                  <li>Participants must comply with all terms and conditions to remain eligible for prizes.</li>
                </ul>
              </div>
            </div>

            <div className="accordion-item">
              <button className="accordion-header">
                <span className="accordion-icon">▼</span>
                <span className="accordion-title">Prize Distribution</span>
                <i data-lucide="chevron-down" className="accordion-chevron"></i>
              </button>
              <div className="accordion-content">
                <ul className="terms-list">
                  <li>Winners are selected randomly using a transparent and auditable selection process.</li>
                  <li>Prize amounts are final and non-negotiable as specified in the current prize structure.</li>
                  <li>Winners will be notified via registered email and phone number within 7 business days.</li>
                  <li>Prizes must be claimed within 30 days of notification, or they will be forfeited.</li>
                  <li>All applicable taxes and fees are the responsibility of the winner.</li>
                  <li>Prize money will be transferred directly to the winner's verified bank account.</li>
                </ul>
              </div>
            </div>

            <div className="accordion-item">
              <button className="accordion-header">
                <span className="accordion-icon">▼</span>
                <span className="accordion-title">General Rules</span>
                <i data-lucide="chevron-down" className="accordion-chevron"></i>
              </button>
              <div className="accordion-content">
                <ul className="terms-list">
                  <li>Offer Lifetime# reserves the right to modify, suspend, or terminate the program at any time.</li>
                  <li>All decisions made by Offer Lifetime# regarding winner selection and prize distribution are final.</li>
                  <li>Fraudulent activity, misrepresentation, or violation of terms will result in immediate disqualification.</li>
                  <li>Participants agree to allow Offer Lifetime# to use their testimonials and feedback (with consent).</li>
                  <li>By participating, you agree to receive communications from Offer Lifetime# regarding the program.</li>
                  <li>Offer Lifetime# is not responsible for technical issues that may affect participation or notification.</li>
                  <li>These terms are governed by applicable laws and regulations.</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="text-center mt-medium">
            <p className="text-gray mb-small">For complete terms and conditions, please visit:</p>
            <Link to="/terms" className="text-blue underline font-semibold">Terms & Conditions</Link>
          </div>
        </div>
      </section>

      <section className="section section-cards">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title" style={{ color: 'white' }}>Why Choose Offer Lifetime#?</h2>
            <p className="section-description" style={{ color: '#9ca3af' }}>Discover what makes us the most trusted platform for prize opportunities</p>
          </div>

          <div className="wrapper">
            <div className="box">
              <span></span>
              <div className="content">
                <h2>Transparent Process</h2>
                <p>Every step is clear and documented. We believe in complete transparency from VIP token purchase to prize distribution.</p>
                <a href="#participate">Get Started</a>
              </div>
            </div>
            <div className="box">
              <span></span>
              <div className="content">
                <h2>Fair & Secure</h2>
                <p>Our random selection process is completely fair and unbiased. Your data and transactions are 100% secure.</p>
                <a href="#about">Learn More</a>
              </div>
            </div>
            <div className="box">
              <span></span>
              <div className="content">
                <h2>Real Winners</h2>
                <p>Join thousands of satisfied winners who have received their prizes. Check our winners gallery for proof.</p>
                <a href="#winners">View Winners</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ContactForm />

      <Footer />
    </div>
  );
};

export default Home;
